import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { uerActsKC2AnalyticsByUerGql } from '../../workOrderQueries';

interface IUseActsKC2AnalyticsByUer {
    workOrderId: number;
    workOrderRootObjectId?: number;
    withEffect?: boolean;
}

const requestId = 'uerActsKC2AnalyticsByUer';

export const useActsKC2AnalyticsByUer = (props: IUseActsKC2AnalyticsByUer) => {
    const { workOrderId, workOrderRootObjectId, withEffect } = props;

    const [uerActsKC2AnalyticsByUerReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => ({ workOrderId, workOrderRootObjectId }), [workOrderId, workOrderRootObjectId]);

    const [uerActsKC2AnalyticsByUerData, uerActsKC2AnalyticsByUerStatus] = useRequest({
        requestId,
        query: uerActsKC2AnalyticsByUerGql,
        variables,
        withEffect,
    });

    useEffect(() => {
        uerActsKC2AnalyticsByUerReset(undefined);
    }, [uerActsKC2AnalyticsByUerReset]);

    return {
        uerActsKC2AnalyticsByUerData,
        uerActsKC2AnalyticsByUerStatus,
    };
};
